import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchValue: '',
  categoryName: 'Все продукты',
  categoryId: 0,
  currentPage: 1,
  sort: {
    name: 'популярности',
    sortProperty: 'rating',
  },
};

const filterSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    setCategoryId(state, action) {
      state.categoryId = action.payload;
    },
    setCategoryName(state, action) {
      state.categoryName = action.payload;
    },
    setSearchValue(state, action) {
      state.searchValue = action.payload;
    },

    setSortBy(state, action) {
      state.sort = action.payload;
    },
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setFilters(state, action) {
      state.currentPage = Number(action.payload.currentPage);
      state.sort = action.payload.sort;
      state.categoryId = Number(action.payload.categoryId);
    },
  },
});

export const sortSelector = (state) => state.filter.sort; //Redux Selector
export const { setCategoryId, setCategoryName, setSortBy, setCurrentPage, setFilters, setSearchValue } =
  filterSlice.actions;
export default filterSlice.reducer;
